import type { ApiResponse } from '../types';

/** 从发送验证码接口响应中取出 mockCode（兼容 data 为 null/嵌套差异） */
export function extractSendCodeMockCode(
  res: ApiResponse<{ mockCode?: string } | null>
): string | undefined {
  const raw = res?.data as unknown;
  if (raw == null || typeof raw !== 'object') return undefined;
  const c = (raw as { mockCode?: unknown }).mockCode;
  if (c === undefined || c === null || c === '') return undefined;
  return String(c);
}
